<template>
    <div class="container h-100">
      <div class="d-flex justify-content-center h-100">
        <div class="user_card">
          <div class="d-flex justify-content-center">
            <div class="brand_logo_container">
              <img
                src="images/logo.jpg"
                class="brand_logo"
                alt="Logo"
              />
            </div>
          </div>
          <h5 style="color:white;" class="mt-4 d-flex justify-content-center"> Verification Code</h5>
          <p style="color:white;"> We’ve just send you 4 digits code to your registered Email address.</p>
          <div class="d-flex justify-content-center">
            <form class="login-form">
              <div class="input-group mb-2">
                <div class="input-group-append">
                  <!-- <span class="input-group-text"
                    ><i class="fas fa-user"></i
                  ></span> -->
                </div>
                <input type="text" name="" class="form-control input_user" @keyup="validateOTP" v-model="otp" placeholder="OTP"/>
              </div>
            <div v-if="otp_error" class="alertError">{{ otp_error }}</div>
              <div class="d-flex justify-content-center  login_container">
                <button type="button" v-on:click="verify" @click="toast" name="button" class="btn login_btn">
                  Verify
                </button>
              </div>  
            </form>
          </div>
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { defineComponent } from 'vue'
  import { createToast } from 'mosha-vue-toastify';
  import 'mosha-vue-toastify/dist/style.css'
  import { base_url } from "../../config";
  import axios from "../../services/customAxios";
  export default defineComponent({
    name:'Login',
    setup () {
      const toast = () => {
          createToast()
      }
      return { toast }
    },
    data() {
      return {
        otp: "",
        otp_error:"",
        id:localStorage.getItem('ForgotId'),
        base_url: base_url,
      };
    },
    methods:{
    async verify(){
      try{
      let response = await axios.post(`${base_url}/submit_otp`, {
        otp: this.otp,
        id: this.id,
      });
        createToast({title: "Success", description: response.data.message},{type: "default"})
      this.$router.push({ name: "ResetPass" });
      } catch(error){
        createToast({title: "Error", description: error?.response?.data?.message},{type: "danger"})
      }
    },
    validateOTP(){
      var numbers = /^[0-9]+$/;
      if(this.otp.length >4 || this.otp.length < 4) {
        this.otp_error = 'OTP length is only 4 digits';	
      }else if (!this.otp.match(numbers)){
        this.otp_error = 'OTP contains Digits only.';	
      } else {
        this.otp_error = '';
      }
    },
  }
  });
  </script>
  
  <style  scoped>
  .white{
    color: white;
  }
  </style>